'use client';

import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useEffect, useState } from 'react';

export default function ImagesCarousel({ images }: { images: string[] }) {
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    const imageClasses =
        'object-cover lg:group-hover:scale-125 transition-all duration-1000 ease-in-out';

    useEffect(() => {
        if (images.length > 1) {
            const intervalId = setInterval(() => {
                setCurrentIndex((prevIndex) =>
                    prevIndex === images.length - 1 ? 0 : prevIndex + 1,
                );
            }, 5000);

            return () => clearInterval(intervalId);
        }
    }, [images.length]);

    const handleDotClick = (index: number) => setCurrentIndex(index);

    if (images.length === 1) {
        return <Image className={imageClasses} fill src={images[0]} alt="Item" />;
    }

    return (
        <div className="relative h-full w-full overflow-hidden">
            {images.map((src, index) => (
                <Image
                    key={index}
                    className={cn(
                        imageClasses,
                        index === currentIndex ? 'opacity-100' : 'opacity-0',
                    )}
                    fill
                    src={src}
                    alt="Item"
                />
            ))}

            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-[6px]">
                {images.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => handleDotClick(index)}
                        className={cn(
                            'h-[10px] w-[10px] rounded-full transition cursor-pointer',
                            index === currentIndex ? 'bg-blue-grey' : 'bg-light-grey',
                        )}
                    ></button>
                ))}
            </div>
        </div>
    );
}
